import { useRef, useState } from "react";
import Webcam from "react-webcam";
import { mainTable } from "../css/Common";
import { ImageAPI } from "../services/APIConnection";
import toast from "react-hot-toast";

const CameraComponent = ({ showImage, apiCall, modalName, captureLimit = 1,index,guestIndex }) => {
  const webcamRef = useRef(null);
  const [isCameraOn, setIsCameraOn] = useState(false);
  const [capturedImages, setCapturedImages] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [showCapturedView, setShowCapturedView] = useState(false);

  const handleStartCaptureClick = () => {
    setCapturedImages([]);
    setShowCapturedView(false);
    setIsCameraOn(true);
  };

  const handleStopCaptureClick = () => {
    setIsCameraOn(false);
  };

    const handleCaptureImageClick = () => {
    if (capturedImages.length >= captureLimit) {
      toast.error(`You can only capture up to ${captureLimit} images.`, {
        duration: 3000,
        position: "top-center",
      });
      return;
    }

    const imageSrc = webcamRef.current.getScreenshot();
    const updatedList = [...capturedImages, imageSrc];
    setCapturedImages(updatedList);

    if (showImage) {
      showImage(index, guestIndex, imageSrc); // ✅ now sends with indexes
    }

    setShowCapturedView(true);
  };

  const handleImageCancel = (index) => {
    const updatedImages = [...capturedImages];
    updatedImages.splice(index, 1);
    setCapturedImages(updatedImages);

    // If no images left, go back to camera view
    if (updatedImages.length === 0) {
      setShowCapturedView(false);
    }
  };

  const handleUploadImage = async (imageBase64) => {
    try {
      setUploading(true);

      const uniqueId = new Date().toISOString().replace(/[-:.TZ]/g, "");
      const fileName = `Photo_${uniqueId}.jpg`;

      const byteString = atob(imageBase64.split(",")[1]);
      const mimeString = imageBase64.split(",")[0].split(":")[1].split(";")[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
      const blob = new Blob([ab], { type: mimeString });

      const formData = new FormData();
      formData.append(modalName, blob, fileName);

      const response = await ImageAPI(formData, apiCall);

      if (showImage) {
        showImage(index, guestIndex, response.data); // ✅ send uploaded data with indexes
      }

      toast.success("Image uploaded successfully 📷", {
        duration: 3000,
        position: "top-center",
      });
    } catch (error) {
      console.error("Error uploading image:", error);
      toast.error("Failed to upload image 👎", {
        duration: 2000,
        position: "top-center",
      });
    } finally {
      setUploading(false);
    }
  };


  return (
    <div>
      {isCameraOn && !showCapturedView && (
        <div className="w-44">
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
          />
          <div className="mt-2 flex gap-2">
            <input
              type="button"
              className={mainTable.addButton}
              onClick={handleStopCaptureClick}
              value="Stop Camera"
            />
            <input
              type="button"
              className={mainTable.addButton}
              onClick={handleCaptureImageClick}
              value="Capture Image"
            />
          </div>
        </div>
      )}

      {showCapturedView && capturedImages.length > 0 && (
        <div className="mt-4">
          <h2>Captured Images:</h2>
          <div className="flex flex-wrap">
            {capturedImages.map((imgSrc, index) => (
              <div key={index} className="m-2 p-2 border rounded">
                <img
                  src={imgSrc}
                  alt={`Captured ${index + 1}`}
                  className="w-44 h-32"
                />
                <div className="mt-2 flex gap-2">
                  <input
                    type="button"
                    className={mainTable.addButton}
                    onClick={() => handleImageCancel(index)}
                    value="Delete"
                  />
                  <input
                    type="button"
                    className={mainTable.addButton}
                    disabled={uploading}
                    onClick={() => handleUploadImage(imgSrc)}
                    value={uploading ? "Uploading..." : "Upload"}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {!isCameraOn && !showCapturedView && (
        <input
          type="button"
          onClick={handleStartCaptureClick}
          className={mainTable.addButton}
          value="Start Camera"
        />
      )}
    </div>
  );
};

export default CameraComponent;
